import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { SharedFunctions } from '../../../../../src/app/shared/shared.functions';

import { PersonaService, TenantService, UnidadFuncionalTipoRelacionService } from '../../../../../src/app/shared/services';
import { UnidadFuncionalTipoRelacion, SearchUnidadFuncionalTipoRelacionRequest, SaveUnidadFuncionalPersona, DialogPersonaSearchComponentRequestDto, DialogPersonaSearchComponentResponseDto, LocalStorageKeys, TenantFeatureFlags, DialogConfirmRequest, SearchPersonaRequestDto, DialogConfirmResponse, SavePersonaDto } from '../../../../../src/app/shared/model';

import { DialogPersonaSearchComponent } from '../../usuarios/components/dialogPersonaSearch.component';
import { DialogConfirmComponent } from '../../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-dialogUnidadFuncionalPersonaGestion',
  templateUrl: 'dialogUnidadFuncionalPersonaGestion.component.html',
  styleUrls: ['./dialogUnidadFuncionalPersonaGestion.component.css']
})

export class DialogUnidadFuncionalPersonaGestionComponent implements OnInit {

  formGroup: FormGroup;
  tipoRelacionList: UnidadFuncionalTipoRelacion[];
  enviarInvitacion: boolean = false;
  enviarExpensa: boolean = false;

  isTipoRelacionSearching: boolean = false;
  isPersonaSaving: boolean = false;
  isPersonaDataSearching: boolean = false;

  tenantFeatureFlags: TenantFeatureFlags;

  constructor(
    private dialogRef: MatDialogRef<DialogUnidadFuncionalPersonaGestionComponent>,
    @Inject(MAT_DIALOG_DATA) public input: SaveUnidadFuncionalPersona,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private tipoRelacionService: UnidadFuncionalTipoRelacionService,
    private personaService: PersonaService,
    private tenantService: TenantService
  ) {
    this.buildForm();
  }

  ngOnInit(): void {
    this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
      if (dataTenant != null && dataTenant.Success) {
        this.tenantFeatureFlags = dataTenant.Result;
        this.loadView();
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err, true);
    })
  }

  loadView() {
    if (this.input != null) {
      this.formGroup.patchValue(this.input);
      this.enviarExpensa = this.input.EnviarExpensa;
    }

    this.getTiposRelacion();
  }

  setTipoRelacion() {
    var tr = this.tipoRelacionList?.filter(f => f.Id == this.input?.TipoRelacionId);
    if (tr != null && tr.length > 0)
      this.formGroup.get("TipoRelacion")?.setValue(tr[0]);
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Id': [0],
      'UnidadFuncionalId': [this.input?.UnidadFuncionalId],
      'UnidadFuncionalNumero': [this.input?.UnidadFuncionalNumero],
      'PersonaNombre': [null, [Validators.required, Validators.maxLength(150)]],
      'PersonaApellido': [null, [Validators.required, Validators.maxLength(150)]],
      'PersonaMailContacto': [null, [Validators.required, Validators.email, Validators.maxLength(255)]],
      'PersonaId': [0],
      'TipoRelacion': [null, Validators.required],
      'TipoRelacionId': [0],
      'TipoRelacionNombre': [null],
      'PuedeEnviarInvitacion': [true],
      'EnviarExpensa': [true],
      'grid-index': [null]
    });
  }

  getTiposRelacion() {
    var r = new SearchUnidadFuncionalTipoRelacionRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoRelacionSearching = true;

    this.tipoRelacionService.search(r).subscribe(data =>{
      this.isTipoRelacionSearching = false;
      if (data != null) {
        this.tipoRelacionList = data.result;
        this.setTipoRelacion();
      }
    },
    (err: HttpErrorResponse) => {
      this.isTipoRelacionSearching = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  getErrorTipoRelacion() {
    var v = this.formGroup.get('TipoRelacion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    return '';
  }

  getErrorPersonaNombre() {
    var v = this.formGroup.get('PersonaNombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorPersonaApellido() {
    var v = this.formGroup.get('PersonaApellido');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorPersonaMailContacto() {
    var v = this.formGroup.get('PersonaMailContacto');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 255 caracteres alcanzado';
    if (v?.hasError('email'))
      return 'Debe ingresar un email con formato válido';
    return '';
  }

  onTipoRelacionSelect() {
    var tr = this.formGroup.get("TipoRelacion")?.value;

    this.formGroup.get("TipoRelacionId")?.setValue(tr?.Id);
    this.formGroup.get("TipoRelacionNombre")?.setValue(tr?.Nombre);
  }

  onGuardar() {
    this.onTipoRelacionSelect();

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var nuevaRelacion = new SaveUnidadFuncionalPersona(0, null, null, null, null, null, null, null, null, false, false, false, null, null);
    nuevaRelacion = {
      ...this.formGroup.value,
      ...{
        EnviarInvitacion: this.enviarInvitacion,
        EnviarExpensa: this.enviarExpensa,
        EnviarExpensaTexto: (this.enviarExpensa ? "Sí" : "No")
      }
    };
    nuevaRelacion.PuedeEnviarInvitacion = (nuevaRelacion.PersonaMailContacto != null && nuevaRelacion.PersonaMailContacto.length > 0 && !this.enviarInvitacion);

    if (nuevaRelacion.EnviarInvitacion && (nuevaRelacion.PersonaMailContacto == null || nuevaRelacion.PersonaMailContacto.length == 0)) {
      this.sharedFunctions.showMessage("Debe ingresar un mail válido para poder enviar la invitación", "Error");
      return false;
    }

    var personaId = this.formGroup.get("PersonaId")?.value;

    //Si dio de alta una persona nueva, la agrego en la DB
    if (personaId == null || personaId <= 0) {
      var r = new SavePersonaDto(
        0,
        this.formGroup.get("PersonaNombre")?.value,
        this.formGroup.get("PersonaApellido")?.value,
        null, null, null,
        this.formGroup.get("PersonaMailContacto")?.value,
        null, null, true, null, null, null, null, null, null
      )

      this.isPersonaSaving = true;
      this.personaService.save(r).subscribe(data => {
        this.isPersonaSaving = false;
        if (data != null && data.Success && data.Result.Id != null && data.Result.Id > 0) {
          nuevaRelacion.PersonaId = data.Result.Id;
          this.dialogRef.close(nuevaRelacion);
        }
        else
          this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
      },
      (err: HttpErrorResponse) => {
        this.isPersonaSaving = false;
        this.sharedFunctions.handleError(err, true);
      })
    }
    else
      this.dialogRef.close(nuevaRelacion);
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onPersonSearchClick() {
    // if (this.isProcessing())
    //     return;

    const dialogRef = this.dialog.open(DialogPersonaSearchComponent, {
      width: '90%',
      data: new DialogPersonaSearchComponentRequestDto(false, 0)
    });

    dialogRef.afterClosed().subscribe((result: DialogPersonaSearchComponentResponseDto) => {
      if (result != null && !result.Cancelled) {
        var personaSeleccionada = (result.Items != null && result.Items.length > 0 ? result.Items[0] : null);

        if (personaSeleccionada != null && personaSeleccionada.Id != null && personaSeleccionada.Id > 0)
          this.formGroup.get("PersonaNombre")?.setValue(personaSeleccionada.Nombre);
          this.formGroup.get("PersonaApellido")?.setValue(personaSeleccionada?.Apellido);
          this.formGroup.get("PersonaMailContacto")?.setValue(personaSeleccionada?.MailContacto);
          this.formGroup.get("PersonaId")?.setValue(personaSeleccionada?.Id);
      }
    });
  }

  onPersonDeassociateClick() {
    this.formGroup.get("PersonaNombre")?.setValue(null);
    this.formGroup.get("PersonaApellido")?.setValue(null);
    this.formGroup.get("PersonaMailContacto")?.setValue(null);
    this.formGroup.get("PersonaId")?.setValue(0);
  }

  checkPersonaExistance() {
    var personaMail = this.formGroup?.get("PersonaMailContacto")?.value;

    if (personaMail != null && personaMail?.length > 0) {
      var r = new SearchPersonaRequestDto(null, null, true, "Apellido", null, null, null, null, null, personaMail, null, true, false);
      this.isPersonaDataSearching = true;

      this.personaService.search(r).subscribe(data => {
        this.isPersonaDataSearching = false;
        if (data != null && data.result != null && data.result.length > 0) {
          var personaSearchResult = data?.result[0];

          if (personaSearchResult.Id == this.formGroup.get("PersonaId")?.value) {
            personaSearchResult = null;
            return;
          }

          var msg = "Se encontró a la persona " + personaSearchResult.Nombre + " " + personaSearchResult.Apellido + " en base al mail ingresado";
          msg += "\n\n¿Desea cargar los datos encontrados?"

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            data: new DialogConfirmRequest("Persona encontrada", msg, "Sí, carga los datos", "No cargues nada")
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted) {
              this.formGroup.get("PersonaNombre")?.setValue(personaSearchResult.Nombre);
              this.formGroup.get("PersonaApellido")?.setValue(personaSearchResult.Apellido);
              this.formGroup.get("PersonaMailContacto")?.setValue(personaSearchResult.MailContacto);
              this.formGroup.get("PersonaId")?.setValue(personaSearchResult.Id);
            }
          });
        }
      },
      (err: HttpErrorResponse) => {
        this.isPersonaDataSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }
}
